import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export interface PartnerRoleBadgesProps {
  isCustomer: boolean;
  isProspect: boolean;
  isSupplier: boolean;
}

/** Rollen-Badges: Ein Partner kann gleichzeitig Kunde, Interessent und Lieferant sein. */
export function PartnerRoleBadges({
  isCustomer,
  isProspect,
  isSupplier,
}: PartnerRoleBadgesProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <span className="flex flex-wrap items-center gap-1">
      {isCustomer ? <Badge variant="success">{t('partners.roles.customer')}</Badge> : null}
      {isProspect ? <Badge variant="warning">{t('partners.roles.prospect')}</Badge> : null}
      {isSupplier ? <Badge variant="secondary">{t('partners.roles.supplier')}</Badge> : null}
    </span>
  );
}
